// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { ModbusInterpretation } from "./modbus-interpretation";
import { ModbusReadType } from "./modbus-read-type";
import { ModbusWordOrder } from "./modbus-word-order";
import { ValuedMessage, ValuedMessageT, verifyValuedMessage } from "../ln2/valued-message";
import { BoolValue, BoolValueT, verifyBoolValue } from "../value/bool-value";
import { ByteValue, ByteValueT, verifyByteValue } from "../value/byte-value";
import { DoubleValue, DoubleValueT, verifyDoubleValue } from "../value/double-value";
import { FloatValue, FloatValueT, verifyFloatValue } from "../value/float-value";
import { IntValue, IntValueT, verifyIntValue } from "../value/int-value";
import { LongValue, LongValueT, verifyLongValue } from "../value/long-value";
import { ShortValue, ShortValueT, verifyShortValue } from "../value/short-value";
import { StringValue, StringValueT, verifyStringValue } from "../value/string-value";
import { UByteValue, UByteValueT, verifyUByteValue } from "../value/ubyte-value";
import { UIntValue, UIntValueT, verifyUIntValue } from "../value/uint-value";
import { ULongValue, ULongValueT, verifyULongValue } from "../value/ulong-value";
import { UShortValue, UShortValueT, verifyUShortValue } from "../value/ushort-value";
import { Value, unionToValue, unionListToValue } from "../value/value";

/**
 * Config-time read mapping: device register → LN2 message.
 * No runtime response data — only describes the request type and how
 * to interpret the result.
 */
export class ModbusReadEntry implements flatbuffers.IUnpackableObject<ModbusReadEntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModbusReadEntry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModbusReadEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: ModbusReadEntry,
  ): ModbusReadEntry {
    return (obj || new ModbusReadEntry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsModbusReadEntry(
    bb: flatbuffers.ByteBuffer,
    obj?: ModbusReadEntry,
  ): ModbusReadEntry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModbusReadEntry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Base register address (before lift offset is added).
   */
  registerAddress(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  /**
   * Type of Modbus read request.
   */
  readType(): ModbusReadType {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModbusReadType.ReadHoldingRegisters;
  }

  /**
   * Number of registers to read.
   */
  quantity(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 1;
  }

  /**
   * How to interpret the register value.
   */
  interpretation(): ModbusInterpretation {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModbusInterpretation.WholeValue;
  }

  /**
   * For `BitmaskSingleBit`: which bit within the register.
   */
  bit(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  /**
   * For `BitmaskSingleBit`: bits per register (8 or 16).
   */
  bitsPerRegister(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 16;
  }

  /**
   * For `WholeValue`: expected value that means "active".
   */
  expectedValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  /**
   * The LN2 message this register maps to. At adapter config time this
   * contains the full `ValuedMessage` (category, variant, enum value, active).
   * At bank/lift expansion time it gets wrapped in a `FrontEndMessage` with
   * the `bank_id` and `lift_id` from bank context.
   */
  ln2Message(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Duplicate this entry per floor at expansion time.
   */
  floorsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Duplicate this entry per lift using bank `offset_mapping`.
   */
  unitsBased(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  /**
   * Human-readable label for the editor UI.
   */
  label(): string | null;
  label(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  label(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  dataTypeType(): Value {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Value.NONE;
  }

  /**
   * Data type for multi-register interpretation. Uses the Value.Value union
   * discriminant from value.fbs to identify the register data type:
   *   NONE / UShortValue → uint16 (1 register, default/backwards compatible)
   *   ShortValue → int16 (1 register)
   *   UIntValue → uint32 (2 registers, combined per word_order)
   *   IntValue → int32 (2 registers)
   *   FloatValue → float32 (2 registers)
   *   ULongValue → uint64 (4 registers)
   * The inner value is unused — only the type discriminant matters.
   */
  dataType<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  /**
   * Word order for combining multi-register values.
   * Only meaningful when data_type requires multiple registers (`UInt`, `Float`, `ULong`).
   */
  wordOrder(): ModbusWordOrder {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ModbusWordOrder.BigEndianWordFirst;
  }

  /**
   * For BitmaskSingleBit paired messages: the LN2 message to emit when
   * this bit is INACTIVE (bit=0 for active-high, bit=1 for active-low).
   * When present, CDO expansion emits a second entry with this message
   * and active=false. Only valid when interpretation=BitmaskSingleBit.
   * Null means unpaired (backward compatible — existing templates read null).
   */
  pairedLn2Message(obj?: ValuedMessage): ValuedMessage | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset
      ? (obj || new ValuedMessage()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startModbusReadEntry(builder: flatbuffers.Builder) {
    builder.startObject(15);
  }

  static addRegisterAddress(builder: flatbuffers.Builder, registerAddress: number) {
    builder.addFieldInt16(0, registerAddress, 0);
  }

  static addReadType(builder: flatbuffers.Builder, readType: ModbusReadType) {
    builder.addFieldInt8(1, readType, ModbusReadType.ReadHoldingRegisters);
  }

  static addQuantity(builder: flatbuffers.Builder, quantity: number) {
    builder.addFieldInt16(2, quantity, 1);
  }

  static addInterpretation(builder: flatbuffers.Builder, interpretation: ModbusInterpretation) {
    builder.addFieldInt8(3, interpretation, ModbusInterpretation.WholeValue);
  }

  static addBit(builder: flatbuffers.Builder, bit: number) {
    builder.addFieldInt8(4, bit, 0);
  }

  static addBitsPerRegister(builder: flatbuffers.Builder, bitsPerRegister: number) {
    builder.addFieldInt8(5, bitsPerRegister, 16);
  }

  static addExpectedValue(builder: flatbuffers.Builder, expectedValue: number) {
    builder.addFieldInt16(6, expectedValue, 0);
  }

  static addLn2Message(builder: flatbuffers.Builder, ln2MessageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, ln2MessageOffset, 0);
  }

  static addFloorsBased(builder: flatbuffers.Builder, floorsBased: boolean) {
    builder.addFieldInt8(8, +floorsBased, +false);
  }

  static addUnitsBased(builder: flatbuffers.Builder, unitsBased: boolean) {
    builder.addFieldInt8(9, +unitsBased, +false);
  }

  static addLabel(builder: flatbuffers.Builder, labelOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, labelOffset, 0);
  }

  static addDataTypeType(builder: flatbuffers.Builder, dataTypeType: Value) {
    builder.addFieldInt8(11, dataTypeType, Value.NONE);
  }

  static addDataType(builder: flatbuffers.Builder, dataTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, dataTypeOffset, 0);
  }

  static addWordOrder(builder: flatbuffers.Builder, wordOrder: ModbusWordOrder) {
    builder.addFieldInt8(13, wordOrder, ModbusWordOrder.BigEndianWordFirst);
  }

  static addPairedLn2Message(
    builder: flatbuffers.Builder,
    pairedLn2MessageOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(14, pairedLn2MessageOffset, 0);
  }

  static endModbusReadEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): ModbusReadEntryT {
    return new ModbusReadEntryT(
      this.registerAddress(),
      this.readType(),
      this.quantity(),
      this.interpretation(),
      this.bit(),
      this.bitsPerRegister(),
      this.expectedValue(),
      this.ln2Message() !== null ? this.ln2Message()!.unpack() : null,
      this.floorsBased(),
      this.unitsBased(),
      this.label(),
      this.dataTypeType(),
      (() => {
        const temp = unionToValue(this.dataTypeType(), this.dataType.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.wordOrder(),
      this.pairedLn2Message() !== null ? this.pairedLn2Message()!.unpack() : null,
    );
  }

  unpackTo(_o: ModbusReadEntryT): void {
    _o.registerAddress = this.registerAddress();
    _o.readType = this.readType();
    _o.quantity = this.quantity();
    _o.interpretation = this.interpretation();
    _o.bit = this.bit();
    _o.bitsPerRegister = this.bitsPerRegister();
    _o.expectedValue = this.expectedValue();
    _o.ln2Message = this.ln2Message() !== null ? this.ln2Message()!.unpack() : null;
    _o.floorsBased = this.floorsBased();
    _o.unitsBased = this.unitsBased();
    _o.label = this.label();
    _o.dataTypeType = this.dataTypeType();
    _o.dataType = (() => {
      const temp = unionToValue(this.dataTypeType(), this.dataType.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.wordOrder = this.wordOrder();
    _o.pairedLn2Message =
      this.pairedLn2Message() !== null ? this.pairedLn2Message()!.unpack() : null;
  }

  unpackFields(...fields: string[]): ModbusReadEntryT {
    const t = new ModbusReadEntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("register_address")) {
      t.registerAddress = this.registerAddress();
    }
    if (fieldSet.has("read_type")) {
      t.readType = this.readType();
    }
    if (fieldSet.has("quantity")) {
      t.quantity = this.quantity();
    }
    if (fieldSet.has("interpretation")) {
      t.interpretation = this.interpretation();
    }
    if (fieldSet.has("bit")) {
      t.bit = this.bit();
    }
    if (fieldSet.has("bits_per_register")) {
      t.bitsPerRegister = this.bitsPerRegister();
    }
    if (fieldSet.has("expected_value")) {
      t.expectedValue = this.expectedValue();
    }
    if (fieldSet.has("ln2_message")) {
      t.ln2Message = this.ln2Message() !== null ? this.ln2Message()!.unpack() : null;
    }
    if (fieldSet.has("floors_based")) {
      t.floorsBased = this.floorsBased();
    }
    if (fieldSet.has("units_based")) {
      t.unitsBased = this.unitsBased();
    }
    if (fieldSet.has("label")) {
      t.label = this.label();
    }
    if (fieldSet.has("data_type_type")) {
      t.dataTypeType = this.dataTypeType();
    }
    if (fieldSet.has("data_type")) {
      t.dataType = (() => {
        const temp = unionToValue(this.dataTypeType(), this.dataType.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("word_order")) {
      t.wordOrder = this.wordOrder();
    }
    if (fieldSet.has("paired_ln2_message")) {
      t.pairedLn2Message =
        this.pairedLn2Message() !== null ? this.pairedLn2Message()!.unpack() : null;
    }
    return t;
  }
}

export class ModbusReadEntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public registerAddress: number = 0,
    public readType: ModbusReadType = ModbusReadType.ReadHoldingRegisters,
    public quantity: number = 1,
    public interpretation: ModbusInterpretation = ModbusInterpretation.WholeValue,
    public bit: number = 0,
    public bitsPerRegister: number = 16,
    public expectedValue: number = 0,
    public ln2Message: ValuedMessageT | null = null,
    public floorsBased: boolean = false,
    public unitsBased: boolean = false,
    public label: string | Uint8Array | null = null,
    public dataTypeType: Value = Value.NONE,
    public dataType:
      | BoolValueT
      | ByteValueT
      | DoubleValueT
      | FloatValueT
      | IntValueT
      | LongValueT
      | ShortValueT
      | StringValueT
      | UByteValueT
      | UIntValueT
      | ULongValueT
      | UShortValueT
      | null = null,
    public wordOrder: ModbusWordOrder = ModbusWordOrder.BigEndianWordFirst,
    public pairedLn2Message: ValuedMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const ln2Message = this.ln2Message !== null ? this.ln2Message!.pack(builder) : 0;
    const label = this.label !== null ? builder.createString(this.label!) : 0;
    const dataType = builder.createObjectOffset(this.dataType);
    const pairedLn2Message =
      this.pairedLn2Message !== null ? this.pairedLn2Message!.pack(builder) : 0;

    ModbusReadEntry.startModbusReadEntry(builder);
    ModbusReadEntry.addRegisterAddress(builder, this.registerAddress);
    ModbusReadEntry.addReadType(builder, this.readType);
    ModbusReadEntry.addQuantity(builder, this.quantity);
    ModbusReadEntry.addInterpretation(builder, this.interpretation);
    ModbusReadEntry.addBit(builder, this.bit);
    ModbusReadEntry.addBitsPerRegister(builder, this.bitsPerRegister);
    ModbusReadEntry.addExpectedValue(builder, this.expectedValue);
    ModbusReadEntry.addLn2Message(builder, ln2Message);
    ModbusReadEntry.addFloorsBased(builder, this.floorsBased);
    ModbusReadEntry.addUnitsBased(builder, this.unitsBased);
    ModbusReadEntry.addLabel(builder, label);
    ModbusReadEntry.addDataTypeType(builder, this.dataTypeType);
    ModbusReadEntry.addDataType(builder, dataType);
    ModbusReadEntry.addWordOrder(builder, this.wordOrder);
    ModbusReadEntry.addPairedLn2Message(builder, pairedLn2Message);

    return ModbusReadEntry.endModbusReadEntry(builder);
  }

  clone(): ModbusReadEntryT {
    const obj = new ModbusReadEntryT();
    obj.registerAddress = this.registerAddress;
    obj.readType = this.readType;
    obj.quantity = this.quantity;
    obj.interpretation = this.interpretation;
    obj.bit = this.bit;
    obj.bitsPerRegister = this.bitsPerRegister;
    obj.expectedValue = this.expectedValue;
    obj.ln2Message = this.ln2Message !== null ? this.ln2Message!.clone() : null;
    obj.floorsBased = this.floorsBased;
    obj.unitsBased = this.unitsBased;
    obj.label = this.label;
    obj.dataTypeType = this.dataTypeType;
    obj.dataType =
      this.dataType !== null && typeof (this.dataType as any).clone === "function"
        ? (this.dataType as any).clone()
        : this.dataType;
    obj.wordOrder = this.wordOrder;
    obj.pairedLn2Message = this.pairedLn2Message !== null ? this.pairedLn2Message!.clone() : null;
    return obj;
  }

  equals(other: ModbusReadEntryT): boolean {
    if (this.registerAddress !== other.registerAddress) return false;
    if (this.readType !== other.readType) return false;
    if (this.quantity !== other.quantity) return false;
    if (this.interpretation !== other.interpretation) return false;
    if (this.bit !== other.bit) return false;
    if (this.bitsPerRegister !== other.bitsPerRegister) return false;
    if (this.expectedValue !== other.expectedValue) return false;
    if (this.ln2Message !== null && other.ln2Message !== null) {
      if (!this.ln2Message!.equals(other.ln2Message!)) return false;
    } else if (this.ln2Message !== other.ln2Message) return false;
    if (this.floorsBased !== other.floorsBased) return false;
    if (this.unitsBased !== other.unitsBased) return false;
    if (this.label !== other.label) return false;
    if (this.dataTypeType !== other.dataTypeType) return false;
    if (this.dataType !== null && other.dataType !== null) {
      if (typeof (this.dataType as any).equals === "function") {
        if (!(this.dataType as any).equals(other.dataType)) return false;
      } else if (this.dataType !== other.dataType) return false;
    } else if (this.dataType !== other.dataType) return false;
    if (this.wordOrder !== other.wordOrder) return false;
    if (this.pairedLn2Message !== null && other.pairedLn2Message !== null) {
      if (!this.pairedLn2Message!.equals(other.pairedLn2Message!)) return false;
    } else if (this.pairedLn2Message !== other.pairedLn2Message) return false;
    return true;
  }
}

export function verifyModbusReadEntry(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 2);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 2);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 18);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 26, 1);
    verifier.checkUnionConsistency(tablePos, 26, 28, "data_type");
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 26);
        switch (uType) {
          case 1: // BoolValue
            {
              const o = verifier.readInt32(pos);
              verifyBoolValue(verifier, pos + o);
            }
            break;
          case 2: // ByteValue
            {
              const o = verifier.readInt32(pos);
              verifyByteValue(verifier, pos + o);
            }
            break;
          case 3: // UByteValue
            {
              const o = verifier.readInt32(pos);
              verifyUByteValue(verifier, pos + o);
            }
            break;
          case 4: // ShortValue
            {
              const o = verifier.readInt32(pos);
              verifyShortValue(verifier, pos + o);
            }
            break;
          case 5: // UShortValue
            {
              const o = verifier.readInt32(pos);
              verifyUShortValue(verifier, pos + o);
            }
            break;
          case 6: // IntValue
            {
              const o = verifier.readInt32(pos);
              verifyIntValue(verifier, pos + o);
            }
            break;
          case 7: // UIntValue
            {
              const o = verifier.readInt32(pos);
              verifyUIntValue(verifier, pos + o);
            }
            break;
          case 8: // LongValue
            {
              const o = verifier.readInt32(pos);
              verifyLongValue(verifier, pos + o);
            }
            break;
          case 9: // ULongValue
            {
              const o = verifier.readInt32(pos);
              verifyULongValue(verifier, pos + o);
            }
            break;
          case 10: // FloatValue
            {
              const o = verifier.readInt32(pos);
              verifyFloatValue(verifier, pos + o);
            }
            break;
          case 11: // DoubleValue
            {
              const o = verifier.readInt32(pos);
              verifyDoubleValue(verifier, pos + o);
            }
            break;
          case 12: // StringValue
            {
              const o = verifier.readInt32(pos);
              verifyStringValue(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkScalarField(tablePos, 30, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 32);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyValuedMessage(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
